import { login, getInfo, loginEmail, logout, loginAccount } from '@/api/user'
import { Message } from 'element-ui'
import { setToken, removeToken } from '@/store/local/auth'
import trackingService from '@/utils/tracking'

const getDefaultState = () => {
  return {
    name: '',
    avatar: ''
  }
}

const state = getDefaultState()

const mutations = {
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState())
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  }
}

const actions = {
/*   loginEmail({ commit }, data) {
    const { mobile, code } = data
    return new Promise((resolve, reject) => {
      loginEmail({ mobile: mobile, code: code })
        .then(response => {
          if (response.data.code == 1) {
            setToken(response.data.data.token)
            location.reload()
          }
          resolve()
        }).catch(error => {
          reject(error)
        })
    })
  }, */
  loginEmail({ commit }, data) {
    const { mobile, code } = data;
    const loginStartTime = Date.now();
    return new Promise((resolve, reject) => {
      loginEmail({ mobile, code })
        .then(response => {
          if (response.data.code === 1) {
            const { token, name, avatar, account } = response.data.data;
            const userId = account || mobile;
            const loginDuration = Date.now() - loginStartTime;
            setToken(token);
            commit('SET_NAME', name); // 同步更新用户信息
            commit('SET_AVATAR', avatar);
            
            // 埋点：用户登录（成功）
            trackingService.trackUserLogin(userId, {
              loginChannel: 'mobile',
              loginType: 'verify_code',
              loginResult: 'success',
              loginDuration: loginDuration
            })
            
            Message({
              message: '您已成功登录，用户：' +  account,
              type: 'success',
              duration: 5 * 1000
            })
            resolve(response.data); // 返回数据供组件使用
          } else {
            // 埋点：用户登录（失败）
            const loginDuration = Date.now() - loginStartTime;
            trackingService.trackUserLogin('', {
              loginChannel: 'mobile',
              loginType: 'verify_code',
              loginResult: 'fail',
              failReason: response.data.msg || 'other',
              loginDuration: loginDuration
            })
            reject(response.data);
          }
        })
        .catch(error => {
          // 埋点：用户登录（失败）
          const loginDuration = Date.now() - loginStartTime;
          trackingService.trackUserLogin('', {
            loginChannel: 'mobile',
            loginType: 'verify_code',
            loginResult: 'fail',
            failReason: 'other',
            loginDuration: loginDuration
          })
          reject(error);
        });
    });
  },

  // 账号密码登录
  loginAccount({ commit }, data) {
    const { account, password, scene } = data;
    const loginStartTime = Date.now();
    return new Promise((resolve, reject) => {
      loginAccount({ account, password, scene })
        .then(response => {
          if (response.data.code === 1) {
            const { token, name, avatar } = response.data.data || {};
            const loginDuration = Date.now() - loginStartTime;
            setToken(token);
            
            // 如果有用户信息，更新到 store
            if (name) commit('SET_NAME', name);
            if (avatar) commit('SET_AVATAR', avatar);
            
            // 埋点：用户登录（成功）
            trackingService.trackUserLogin(account, {
              loginChannel: 'mobile', // 根据实际情况调整
              loginType: 'password',
              loginResult: 'success',
              loginDuration: loginDuration
            })
            
            resolve(response.data); // 返回数据供组件使用
          } else {
            // 埋点：用户登录（失败）
            const loginDuration = Date.now() - loginStartTime;
            trackingService.trackUserLogin('', {
              loginChannel: 'mobile',
              loginType: 'password',
              loginResult: 'fail',
              failReason: response.data.msg?.includes('密码') ? 'password_error' : (response.data.msg?.includes('账号') ? 'account_not_exist' : 'other'),
              loginDuration: loginDuration
            })
            reject(response.data);
          }
        })
        .catch(error => {
          // 埋点：用户登录（失败）
          const loginDuration = Date.now() - loginStartTime;
          trackingService.trackUserLogin('', {
            loginChannel: 'mobile',
            loginType: 'password',
            loginResult: 'fail',
            failReason: 'other',
            loginDuration: loginDuration
          })
          reject(error);
        });
    });
  },

  // TODO: user login 用户登录，获取到token、name和avatar
  login({ commit }, userInfo) {
    const { username, password } = userInfo
    return new Promise((resolve, reject) => {
      login({ username: username.trim(), password: password }).then(response => {
        const { data } = response
        setToken(data.token)
        commit('SET_NAME', data.name)
        commit('SET_AVATAR', data.avatar)
        Message({
          message: '您已成功登录，用户：' + data.token,
          type: 'success',
          duration: 5 * 1000
        })
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  // TODO: get user info 用户修改账号信息后重新获取name和avatar
  // getInfo({ commit, state }) {
  //   return new Promise((resolve, reject) => {
  //     getInfo(state.token).then(response => {
  //       const { data } = response
  //       if (!data) {
  //         return reject('Verification failed, please Login again.')
  //       }
  //       const { name, avatar } = data
  //       commit('SET_NAME', name)
  //       commit('SET_AVATAR', avatar)
  //       resolve(data)
  //     }).catch(error => {
  //       reject(error)
  //     })
  //   })
  // },
  getInfo({ commit }) {
    return new Promise((resolve, reject) => {
      getInfo().then(response => {
        const { data } = response
        if (!data) {
          return reject('获取用户信息失败，请重新登录')
        }
        const { name, avatar } = data
        commit('SET_NAME', name)
        commit('SET_AVATAR', avatar)
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // user logout 用户登出，重设状态
  logout({ commit, state }) {
    return new Promise((resolve, reject) => {
      logout().then(response => {
        if (response.data.code == 1) {
          // 埋点：登出事件
          trackingService.trackLogout()
          
          removeToken()
          commit('RESET_STATE')
          // 清除localStorage中的用户信息
          localStorage.removeItem('userInfo')
          localStorage.removeItem('userAvatar')
          // 清除简历相关的数据
          localStorage.removeItem('resumeData')
          localStorage.removeItem('resumeParsed')
          localStorage.removeItem('resume_id')
          localStorage.removeItem('cv_url')
          localStorage.removeItem('cv_name')
          // 清除岗位要求相关的数据
          localStorage.removeItem('jd_url')
          localStorage.removeItem('jd_name')
          localStorage.removeItem('jobInformation')
          resolve(response)
        } else {
          reject(new Error('退出登录失败'))
        }
      }).catch(error => {
        // 即使接口调用失败，也要清除本地状态
        // 埋点：登出事件
        trackingService.trackLogout()
        
        removeToken()
        commit('RESET_STATE')
        localStorage.removeItem('userInfo')
        localStorage.removeItem('userAvatar')
        // 清除简历相关的数据
        localStorage.removeItem('resumeData')
        localStorage.removeItem('resumeParsed')
        localStorage.removeItem('resume_id')
        localStorage.removeItem('cv_url')
        localStorage.removeItem('cv_name')
        // 清除岗位要求相关的数据
        localStorage.removeItem('jd_url')
        localStorage.removeItem('jd_name')
        localStorage.removeItem('jobInformation')
        reject(error)
      })
    })
  },

}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}

